<div
  class="alert alert-warning alert-dismissible fade show m-0"
  *ngIf="showBanner"
>
  <button
    type="button"
    class="btn-close"
    data-mdb-dismiss="alert"
    (click)="closeBanner()"
  ></button>
  <div class="d-flex align-items-center">
    <i class="fas fa-exclamation-triangle me-2"></i>
    <div>
      <strong>Wartungshinweis:</strong> {{ displayMessage }}
      <span class="d-block mt-1 text-muted small" *ngIf="updatedAt"
        >Letzte Aktualisierung: {{ updatedAt }}</span
      >
    </div>
  </div>
</div>
